var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 12.1667H14.1667M20.8333 17.5H14.1667M20.8333 6.83333H14.1667M9.5 1.5L9.5 25.5M7.9 1.5H19.1C21.3402 1.5 22.4603 1.5 23.316 1.93597C24.0686 2.31947 24.6805 2.93139 25.064 3.68404C25.5 4.53969 25.5 5.65979 25.5 7.9V19.1C25.5 21.3402 25.5 22.4603 25.064 23.316C24.6805 24.0686 24.0686 24.6805 23.316 25.064C22.4603 25.5 21.3402 25.5 19.1 25.5H7.9C5.65979 25.5 4.53969 25.5 3.68404 25.064C2.93139 24.6805 2.31947 24.0686 1.93597 23.316C1.5 22.4603 1.5 21.3402 1.5 19.1V7.9C1.5 5.65979 1.5 4.53969 1.93597 3.68404C2.31947 2.93139 2.93139 2.31947 3.68404 1.93597C4.53969 1.5 5.65979 1.5 7.9 1.5Z",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadResearch);
export default __webpack_public_path__ + "static/media/broad-research.22b8ccefeefbdf83ed09b1885e3ec6cc.svg";
export { ForwardRef as ReactComponent };